import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from '../core/core.module';
import { AuthenticationService } from '../service/authentication.service';
import { UserManagementService } from '../service/userManagement.service';

@Component({
  selector: 'dda-otp-login',
  templateUrl: './otp-login.component.html',
  styleUrls: ['./otp-login.component.scss'],
})
export class OtpLoginComponent implements OnInit {
OtpModel:any={};
  constructor(private fb: FormBuilder,
    private authentication :AuthenticationService,
    private router: Router,
    private notification:NotificationService) { }
    resetPassForm = this.fb.group({
    otp:[null,Validators.compose([
      Validators.required,Validators.pattern('[0-9]+$')
    ])],
  });

  ngOnInit(): void {
  }
  onSubmit(){
    if (this.resetPassForm.invalid) {
      return;
      }
      var mobileNo = sessionStorage.getItem('mobileNo');
      var password = sessionStorage.getItem('passkey');
      const param = {
        'otp':this.OtpModel.otp,
        'mobileNumber': mobileNo,
        'userPassword': password,
      }
     this.authentication.validateOtp(param).subscribe(data=>{
      
     }) 
  }
}
